import { useQuery } from '@tanstack/react-query';

import { PricingPlanUsedIn } from 'src/features/pricingPlan/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/pricing/pricing-plan/:pricingPlanId/linked-entities/';

type QueryFnType = typeof queryFn;

interface DTO {
    parkingId: string;
    pricingPlanId: string;
}
const queryFn = ({ parkingId, pricingPlanId, ...params }: DTO): Promise<PricingPlanUsedIn> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, pricingPlanId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetLinkedEntities };
